module.exports = __webpack_public_path__ + "img/search-solid.55473c27.svg";